import pt from "../../locales/pt.json";
import en from "../../locales/en.json";
import es from "../../locales/es.json";

export const Translations = {pt, en, es};